import React from 'react';
const steps = [{
  number: '01',
  title: 'Descarga el kit completo',
  description: 'Acceso inmediato a tu correo tras el pago.'
}, {
  number: '02',
  title: 'Ejecuta la auditoría',
  description: 'Lleva el control de los 20 sensores durante tus próximas citas. Él no sabrá que lo estás haciendo.'
}, {
  number: '03',
  title: 'Obtén tu veredicto',
  description: 'Verde, Amarillo o Rojo. Sin dudas. Sin negociación contigo misma.'
}];
export function HowItWorksSection() {
  return <section className="px-5 py-10 max-w-[640px] mx-auto" data-id="element-98">
      <span className="inline-block bg-[var(--accent)] text-white text-[11px] font-bold tracking-widest px-3.5 py-1.5 rounded-full mb-4 uppercase" data-id="element-99">
        CÓMO FUNCIONA
      </span>

      <h2 className="text-[clamp(24px,6vw,36px)] font-extrabold leading-tight" data-id="element-100">
        Tres pasos. Sin complicaciones.
      </h2>

      <div className="mt-8" data-id="element-101">
        {steps.map((step, index) => <div key={index} className="mb-8" data-id="element-102">
            <div className="text-[56px] font-black text-[var(--accent)] leading-none" data-id="element-103">
              {step.number}
            </div>
            <h3 className="text-xl font-bold my-1" data-id="element-104">{step.title}</h3>
            <p className="text-white text-[15px]" data-id="element-105">{step.description}</p>
          </div>)}
      </div>
    </section>;
}